<template>
    <div>
        {{ $t('notification.taskWorkflowPipelineStageAdded', { 
            actor: $_.get(activity, 'actorUser.name'), 
            workflowTitle: $_.get(activity, 'payload.workflowTitle'),
            stageName: $_.get(activity, 'payload.stageName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowPipelineStageAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

